'use client';

import { c as _c } from "react/compiler-runtime";
import { PrV2PublishButton } from './comments/pr-v2-publish-button';
import { PrV2ReviewDropdown } from './comments/pr-v2-review-dropdown';
import { PrV2MergeDropdown } from './pr-v2-merge-dropdown';
import { PrV2StackDropdown } from './pr-v2-stack-dropdown';
import { PR_V2_TOP_NAVIGATION_CLASS } from './shared/pr-v2-layout-classes';
import { usePrV2Summary } from '@/data/v2/pr/use-pr-v2-summary';
type PrV2TopNavigationProps = {
  owner: string;
  repo: string;
  number: string;
  className?: string;
  /**
   * Renders for the /code session panel. The stack control then drops its `S`, `[` and `]` keys and
   * hints, which would navigate away from /code.
   */
  inSessionPanel?: boolean;
};
export function PrV2TopNavigation(t0) {
  const $ = _c(15);
  const {
    owner,
    repo,
    number,
    className,
    inSessionPanel: t1
  } = t0;
  const inSessionPanel = t1 === undefined ? false : t1;
  const summaryQuery = usePrV2Summary(owner, repo, number);
  const summary = summaryQuery.data?.pullRequest;
  const initialMergeabilityStatus = summaryQuery.data?.mergeabilityStatus ?? null;
  const t2 = className ?? PR_V2_TOP_NAVIGATION_CLASS;
  let t3;
  if ($[0] !== inSessionPanel || $[1] !== number || $[2] !== owner || $[3] !== repo) {
    t3 = <PrV2StackDropdown owner={owner} repo={repo} number={number} inSessionPanel={inSessionPanel} />;
    $[0] = inSessionPanel;
    $[1] = number;
    $[2] = owner;
    $[3] = repo;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== initialMergeabilityStatus || $[6] !== number || $[7] !== owner || $[8] !== repo || $[9] !== summary) {
    t4 = summary ? <>{summary.draft ? <PrV2PublishButton owner={owner} repo={repo} number={number} summary={summary} /> : <PrV2MergeDropdown owner={owner} repo={repo} number={number} summary={summary} initialMergeabilityStatus={initialMergeabilityStatus} />}<PrV2ReviewDropdown owner={owner} repo={repo} number={number} summary={summary} /></> : null;
    $[5] = initialMergeabilityStatus;
    $[6] = number;
    $[7] = owner;
    $[8] = repo;
    $[9] = summary;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <ul data-pr-v2-mobile-action-bar="" className={t2}>{t3}{t4}</ul>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}